import { TAnalyticsNotesYearlyState } from './types';

export function getForeignTradeTemplateData(state: TAnalyticsNotesYearlyState) {
  return state.foreignTradeTemplateData;
}

export function getForeignTradeTable(state: TAnalyticsNotesYearlyState) {
  return state.foreignTradeTable;
}

export function getExportStructureTable(state: TAnalyticsNotesYearlyState) {
  return state.exportStructureTable;
}

export function getImportStructureTable(state: TAnalyticsNotesYearlyState) {
  return state.importStructureTable;
}

export function getExportProductsTable(state: TAnalyticsNotesYearlyState) {
  return state.exportProductsTable;
}

export function getImportProductsTable(state: TAnalyticsNotesYearlyState) {
  return state.importProductsTable;
}
